import { render, staticRenderFns } from "./CourierCashDetails.vue?vue&type=template&id=77c2f377&"
import script from "./CourierCashDetails.vue?vue&type=script&lang=js&"
export * from "./CourierCashDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports